<template>
  <v-dialog v-model="show" max-width="800">
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.CONTROLLERS.CONTROLLER_LOGS') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="controllerLogs.length">
        <v-data-table
          :headers="[
            {
              text: $vuetify.lang.t('$vuetify.CONTROLLERS.REASON'),
              align: 'start',
              sortable: false,
              value: 'Reason'
            },
            {
              text: 'Timestamp',
              align: 'start',
              sortable: false,
              value: 'Timestamp'
            }
          ]"
          :items="controllerLogs"
        >
        </v-data-table>
      </v-card-text>
      <v-card-text v-else>
        <v-toolbar class="elevation-0 mt-12">
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loading.state && loading.type === 'getControllerLogs'"
            indeterminate
            color="secondary"
          ></v-progress-circular>
          <div v-else>
            <span v-if="!controllerLogs.length">No data</span>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CLOSE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'ControllerLogsDialog',
  mixins: [formatDate],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    controllerId: {
      type: String,
      required: false
    },
    placeId: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('places', ['controllerLogs']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$store.commit('places/setControllerLogs', [])
          this.$emit('close')
        }
      }
    }
  },
  created() {
    this.getControllerLogs({
      placeId: this.placeId,
      controllerId: this.controllerId
    })
  },
  methods: {
    ...mapActions('places', ['getControllerLogs'])
  }
}
</script>
